<template>
    <div>
        <geometry-element
                selectable
                movable
                :connectable="!isReadOnly"
                :deletable="!isReadOnly"
                :id.sync="value.elementView.id"
                :x.sync="value.elementView.x"
                :y.sync="value.elementView.y"
                :width.sync="value.elementView.width"
                :height.sync="value.elementView.height"
                :angle.sync="value.elementView.angle"
                v-on:selectShape="selectedActivity"
                v-on:deSelectShape="deSelectedActivity"
                v-on:rotateShape="onRotateShape"
                v-on:labelChanged="onLabelChanged"
                v-on:addedToGroup="onAddedToGroup"
                v-on:dblclick="showDRulePanel"
                v-on:removeShape="beforeRemove(value); onRemoveShape(value)"
                :label.sync="name"
                :_style="{
                'label-angle':value.elementView.angle,
                'font-weight': 'bold','font-size': '16'
                }">

            <!--v-on:dblclick="$refs['dialog'].open()"-->
            <geometry-rect
                    :_style="{
                        'fill-r': 1,
                        'fill-cx': .1,
                        'fill-cy': .1,
                        'stroke-width': 1.4,
                        'stroke': '#F1A746',
                        fill: '#F1A746',
                        'fill-opacity': 1,
                        r: '1'
                    }"
            ></geometry-rect>
            
            <sub-elements>
                <!--title-->
                <text-element
                        :sub-width="'100%'"
                        :sub-height="25"
                        :sub-top="5"
                        :text="'subset'">
                </text-element>
            </sub-elements>
            <k8s-sub-controller
                    v-for="(connectableType, index) in filterConnectionTypes"
                    :key="index"
                    :element="value"
                    :image="connectableType.src"
                    :type="connectableType.component">
            </k8s-sub-controller>
        </geometry-element>

    </div>
</template>

<script>
    import Element from "../KubernetesElement";

    export default {
        mixins: [Element],
        name: 'destinationRuleSubset',
        components: {},
        props: {},
        computed: {
            imgSrc() {
                return `${ window.location.protocol + "//" + window.location.host}/static/image/symbol/kubernetes/istio/istio-drule.svg`
            },
            className() {
                return 'DestinationRuleSubset'
            },
            createNew(elementId, x, y, width, height, object) {
                return {
                    _type: this.className(),
                    name: '',
                    parentId: '',
                    elementView: {
                        '_type': this.className(),
                        'id': elementId,
                        'x': x,
                        'y': y,
                        'width': width,
                        'height': height,
                        'style': JSON.stringify({}),
                        'angle': 0,
                    },
                    object: {
                        "kind": "DestinationRuleSubset",
                        "metadata": {
                            "name": "",
                            "labels": {
                                "version": "v1"
                            }
                        }
                    },
                    connectableType: ["Deployment", "Pod", "ReplicaSet"],
                    outboundElement: "",
                    routeType: null,
                    weight: null,
                    index: null,
                    host: null,
                    parentObj: object ? object : null
                }
            },
            name() {
                try {
                    return this.value.name;
                } catch (e) {
                    return "Untitled";
                }
            },
            host() {
                try {
                    return this.value.host;
                } catch (e) {
                    return "";
                }
            }
        },
        data: function () {
            return {};
        },
        created: function () {
            var me = this;
            if(me.value.parentId.length < 1) {
                var designer = this.getComponent('kubernetes-model-canvas');
                var compInfo = {
                    'component': "destinationRule",
                    'label': "DestinationRule",
                    'src': `${window.location.protocol + "//" + window.location.host}/static/image/symbol/kubernetes/istio/istio-drule.svg`,
                    'x': me.value.elementView.x+100,
                    'y': me.value.elementView.y
                }
                let el = designer.addElement(compInfo, me.value.parentObj);
                me.value.parentId = el.elementView.id;
                me.value.parentElName = el.object.metadata.name;
                me.value.index = (el.subsets).length;
                me.value.name = el.object.spec.subsets[(el.subsets).length].name;
                me.value.object.metadata.name = me.value.name;
                me.value.host = el.object.spec.host;
                if(el.object.spec.subsets[(el.subsets).length].labels.app) {
                    me.value.object.app = el.object.spec.subsets[(el.subsets).length].labels.app;
                }
                el.subsets.push(me.value);
            }
            me.value.elementView.x = me.value.elementView.x + 1
            me.$nextTick(function () {
                me.value.elementView.x = me.value.elementView.x - 1
            })
        },
        mounted: function () {
            var me = this;
            me.refresh();

            this.$EventBus.$on(`${me.value.elementView.id}`, function (obj) {
                if(obj.action=="addRelation" && obj.element && obj.element.targetElement && 
                    (obj.element.targetElement._type == "Deployment" || obj.element.targetElement._type == "Pod" || obj.element.targetElement._type == "ReplicaSet")) {
                    me.value.outboundElement = obj.element.targetElement;
                    obj.element.targetElement.subsetId = obj.element.sourceElement.elementView.id;
                    this.$EventBus.$emit(`${me.value.parentId}`, obj);
                }
                if(obj.action=="deleteRelation" && obj.element && obj.element.targetElement && 
                    (obj.element.targetElement._type == "Deployment" || obj.element.targetElement._type == "Pod" || obj.element.targetElement._type == "ReplicaSet")) {
                    me.value.outboundElement = null;
                    this.$EventBus.$emit(`${me.value.parentId}`, obj);
                }

                if(obj.action=="addRelation" && obj.element && obj.element.sourceElement && obj.element.sourceElement._type == "VirtualService") {
                    if(me.value.routeType == null && me.value.weight == null) {
                        me.value.routeType = ""
                        me.value.weight = 0
                    }
                }
                if(obj.action=="deleteRelation" && obj.element && obj.element.sourceElement && obj.element.sourceElement._type == "VirtualService") {
                    delete me.value.routeType;
                    delete me.value.weight;
                }
            })
        },
        watch: {
            name(appName) {
                this.value.object.metadata.name = appName;
            },
        },
        methods: {
            deSelectedActivity: function () {
                var me = this;
                if (me.value) {
                    me.selected = false
                    me.openPanel = false
                    
                    var designer = me.getComponent('kubernetes-model-canvas')
                    designer.deSelected(me.value.object)

                    var obj = {
                        action: "closeProperty",
                        element: me.value
                    };
                    me.$EventBus.$emit(`${me.value.parentId}`, obj);
                }
            },
            beforeRemove(value) {
                var me = this;
                var obj = {
                    action: "deleteSubset",
                    element: value
                }
                me.$EventBus.$emit(`${me.value.parentId}`, obj);
            },
            showDRulePanel() {
                var me = this;
                var obj = {
                    action: "showProperty",
                    element: me.value
                };
                me.$EventBus.$emit(`${me.value.parentId}`, obj);
            },
            isConnected(to, from) {
                if(!from.connectableType) {
                    return false
                }
                var connectable = from.connectableType.some((type) => {
                    if(type == to._type) {
                        return true
                    }
                })
                var res = false
                if(connectable) {
                    if(from.object.app == to.object.metadata.name) {
                        res = true
                    }
                }
                return res
            },
        },
    }
</script>

<style>

</style>